import { Identifier } from 'react-admin'

export const PRODUCTS = () => '/products'
export const VARIANTS = () => '/variants'
export const MARKETPLACE_VARIANTS = () => '/marketplace-variants'
export const COMMUNITY_CAMPAIGNS = () => '/community-campaigns'
export const CONTENTS = () => '/contents'
export const CATALOGS = () => '/catalogs'
export const OFFERS = () => '/offers'
export const VARIANTS_MULTI_UPLOADS = () => '/variants/multi-uploads'
export const PARSED_VOUCHER_UPLOAD = () => '/variants/parsed-voucher-upload'
export const VOUCHER_STOCK_UPLOAD_DETAILS = () => '/voucher-stock-upload-details/:id'
export const VOUCHER_STOCK_UPLOAD_DETAILS_ID = (id: Identifier) => `/voucher-stock-upload-details/${id}`
export const VARIANT_COSTS = () => '/variant-costs'
export const POSPRODUCTS = () => '/posproducts'
export const BRANDS = () => '/brands'
export const SUBCATEGORIES = () => '/sub-categories'
export const MAINCATEGORIES = () => '/main-categories'
export const ORDERS = () => '/orders'
export const PROMOCODES = () => '/promo-codes'
export const FEES = () => '/fees'
export const SETTLEMENT = () => '/settlement'
export const VOUCHER_BATCHES = () => '/voucher-batches'

export const MERCHANTS_ORDERS = () => '/merchants/orders'
export const SUPPLIERS_ORDERS = () => '/suppliers/orders'
export const SUPPLIER_MAPPINGS = () => '/supplier-mappings'
export const SUPPLIERS = () => '/suppliers'

export const USERS = () => '/users'
export const ADMINS = () => '/admins'
export const SETTINGS = () => '/settings'
export const CUSTOM = () => '/custom-route'
export const ROLES_AND_PERMISSIONS = () => `/roles-and-permissions`

export const SYSTEM = () => '/system'

// export const LOGIN = () => '/login'
export const RESET_PASSWORD = () => '/resetPassword'
export const DASHBOARD = () => '/dashboard'

export const REFRESH_TOKEN_URL = () => '/auth/refresh-token'
export const AWS_UPLOAD_URL = () => '/dashboard/aws/upload-url'

export const ALLOWED_PAGES = (id: Identifier) => `/allowed-pages/${id}`
export const BULK_PROMO_CODES = () => '/bulk-promo-codes'
export const PROMO_RULES = () => '/promo-rules'
export const PROMO_RULES_ID = (id: Identifier) => `/promo-rules/${id}`

export const CUSTOMER_CARE_IDENTITY_CORRECTION = () => '/customer-care/superqi-identity-correction'
export const CUSTOMER_CARE_BULK_MERGE = () => '/customer-care/superqi-bulk-merge'
export const CUSTOMER_CARE_MERGE_ALL = () => '/customer-care/superqi-merge-all'

export const DEEP_LINK_GENERATOR = () => '/tools/deep-link-generator'
